export default __webpack_public_path__ + "static/media/TEST-2.799c1217.jpeg";